import React, { useEffect } from 'react'
import { Box, Typography, Container } from '@mui/material';
import AOS from 'aos';

const QuoteSection = (props) => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
    
  return (
    <Box sx={{ py: 16, px: { xs: 2, md: 3 },  textAlign: 'center', }} data-aos="fade-up" >
      <Container maxWidth="md">       
        <Typography sx={{ color: 'primary.main', fontWeight:'bold', fontSize: { xs: '1.2rem', md: '1.45rem' }, lineHeight: 1.2, position: 'relative' }}  >
          <span style={{ fontSize: '2rem', color: 'primary.main', lineHeight: 1.2,  marginRight: 4,  }} > &ldquo; </span>
          {props.data}
          <span style={{ fontSize: '2rem', color: 'primary.main', lineHeight: 1,  }} > &rdquo; </span>
        </Typography>
      </Container>
    </Box>
  );
};

export default QuoteSection;
